import React, { useState } from 'react';
import Layer from '../../components/layer/LayerConfirmAdmin';
import "./Administrator.css";
import test from '../../static/images/1.jpg';

export default function Administrator({itemAdmin, listCardAdmin, search, onFetchEvents}) {
    const [administrator, setAdministrator] = useState({});
    const [isSlideOpen, setIsSlideOpen] = useState(false);
    const [loadSlide, setLoadSlide] = useState(false);

    const toggleSlide = (itemAdmin) => {
        setLoadSlide(!loadSlide);
        setAdministrator(itemAdmin);
        setIsSlideOpen(!isSlideOpen);
    };

	return (
        <div className={`listing-item ${listCardAdmin ? "list-layout" : ""}`}>
            <article className="geodir-category-listing fl-wrap">
                <div className="geodir-category-img">
                    <img src={test} alt=""/>
                    <div className="overlay"></div>
                </div>
                <div className="geodir-category-content fl-wrap">
                    <a className="listing-geodir-category" onClick={() => toggleSlide(itemAdmin)}>Conferma Dati</a>
                    <div className="listing-avatar"><a href="#"><img src={test} alt=""/></a>
                        <span className="avatar-tooltip"><strong>Lisa Smith</strong></span>
                    </div>
                    <h3><a href="#">{itemAdmin.name}</a></h3>
                    <p>{itemAdmin.description}</p>
                    <div className="geodir-category-options fl-wrap">
                        <div className="geodir-category-location"><a href="#"><i className="fa fa-map-marker" aria-hidden="true"></i> {itemAdmin.address}, {itemAdmin.comune}({itemAdmin.provincia}) {itemAdmin.cap}</a></div>
                    </div>
                </div>
            </article>
            {/* Slide */}
            { loadSlide && (
                <Layer show={isSlideOpen} onClose={toggleSlide} item={itemAdmin}/>
                )
            }
            {/* Slide */}
        </div>
	);
}